import type { GetOwnersParams } from 'services/ownerApi'

export const ownerQueryKeys = {
  all: ['owners'] as const,
  lists: () => [...ownerQueryKeys.all, 'list'] as const,
  list: (filters: GetOwnersParams) => [...ownerQueryKeys.lists(), filters] as const,
  details: () => [...ownerQueryKeys.all, 'detail'] as const,
  detail: (id: string, params?: { limit?: number; offset?: number }) =>
    [...ownerQueryKeys.details(), id, params] as const,
}
